/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { List, ListItem, Container, Typography, Box, Grid, Divider, Button, IconButton, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import styles from "../../styles/footerStyle.js";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { colors, modernColors } from "../../components/Theme/WebTheme";
import { FONT_FAMILY } from "../../common/sharedFunctions.js";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import BANNER2 from "../../assets/img/banner2.jpg";
const useStyles = makeStyles(styles);

export default function HomeFooter(props) {
  const classes = useStyles();
  const settings = useSelector((state) => state.settingsdata.settings);
  const { whiteFont } = props;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const footerLinks = [
    { text: t('home'), path: '/' },
    { text: t('myaccount'), path: '/bookings' },
    { text: t('about_us'), path: '/about-us' },
    { text: t('contact_us'), path: '/contact-us' },
    { text: t('privacy_policy'), path: '/privacy-policy' },
    { text: t('term_condition'), path: '/term-condition' },
    { text: 'Veri Güvenliği', path: '/veri-guvenligi' },
    { text: 'Satış ve Hizmet Politikası', path: '/satis-ve-hizmet' },
    { text: 'KVKK Aydınlatma Metni', path: '/kvkk-aydinlatma' }
  ];

  return (
    <>
      {/* Banner */}
      <Box sx={{ 
        width: '80%', 
        margin: '40px auto', 
        borderRadius: '16px', 
        overflow: 'hidden', 
        boxShadow: '0 4px 20px rgba(0,0,0,0.06)'
      }}>
        <img src={BANNER2} alt="banner" style={{ width: "100%", height: "auto", display: 'block' }} />
      </Box>
      
      {/* Footer */}
      <Box sx={{ 
        bgcolor: modernColors.textPrimary, 
        color: '#fff', 
        position: 'relative',
        pt: 8,
        pb: 3
      }}>
        {/* Back to top button */}
        <IconButton
          onClick={scrollToTop}
          sx={{ 
            position: 'absolute',
            top: -25,
            left: '50%',
            transform: 'translateX(-50%)',
            bgcolor: modernColors.primary,
            color: modernColors.textPrimary,
            width: 50,
            height: 50,
            '&:hover': {
              bgcolor: '#FFB300',
              transform: 'translateX(-50%) translateY(-5px)',
            },
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            borderRadius: '50%'
          }}
          >
          <KeyboardArrowUpIcon fontSize="medium" />
        </IconButton>
        
        <Container maxWidth="lg">
          <Grid container spacing={4} sx={{ mb: 5 }}>
            {/* Logo and Company Info */}
            <Grid item xs={12} md={4}>
              <Box sx={{ mb: 3 }}>
             
                <Typography 
                  variant="body2" 
                  sx={{ 
                    fontFamily: FONT_FAMILY,
                    color: 'rgba(255,255,255,0.7)',
                    maxWidth: '300px',
                    lineHeight: 1.6
                  }}
                >
                  {settings && settings.CompanyName 
                    ? settings.CompanyName + " - " + t('about_us_content2').substring(0, 100) + "..." 
                    : t('about_us_content2').substring(0, 100) + "..."}
                </Typography>
              </Box>
              
              {/* Contact Information */}
              <Stack spacing={2}>
                {settings && settings.Contact && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PhoneIcon sx={{ color: modernColors.primary, fontSize: 20 }} />
                    <Typography variant="body2" sx={{ fontFamily: FONT_FAMILY }}>
                      {settings.Contact}
                    </Typography>
                  </Box>
                )}
                
                {settings && settings.Email && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <EmailIcon sx={{ color: modernColors.primary, fontSize: 20 }} />
                    <Typography variant="body2" sx={{ fontFamily: FONT_FAMILY }}>
                      {settings.Email}
                    </Typography>
                  </Box>
                )}
                
                {settings && settings.CompanyAddress && (
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                    <LocationOnIcon sx={{ color: modernColors.primary, fontSize: 20, mt: 0.3 }} />
                    <Typography variant="body2" sx={{ fontFamily: FONT_FAMILY }}>
                      {settings.CompanyAddress}
                    </Typography>
                  </Box>
                )}
              </Stack>
            </Grid>
            
            {/* Quick Links */}
            <Grid item xs={12} md={5}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontFamily: FONT_FAMILY, 
                  fontWeight: 600, 
                  mb: 3,
                  color: modernColors.primary,
                  position: 'relative',
                  display: 'inline-block',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    width: '40px',
                    height: '3px',
                    bgcolor: modernColors.primary,
                    bottom: -8,
                    left: 0
                  }
                }}
              >
                {"Hızlı Bağlantılar"}
              </Typography>
              
              <Grid container spacing={1}>
                {footerLinks.map((link, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Button
                      onClick={() => navigate(link.path)}
                      sx={{
                        color: 'white',
                        textTransform: 'none',
                        fontFamily: FONT_FAMILY,
                        justifyContent: 'flex-start',
                        fontWeight: 'normal',
                        padding: '6px 8px',
                        fontSize: '0.875rem',
                        opacity: 0.8,
                        '&:hover': {
                          opacity: 1,
                          color: modernColors.primary,
                          backgroundColor: 'rgba(255, 255, 255, 0.05)'
                        },
                        textAlign: 'left'
                      }}
              >
                      {link.text}
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            
            {/* Social Media */}
            <Grid item xs={12} md={3}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontFamily: FONT_FAMILY, 
                  fontWeight: 600, 
                  mb: 3,
                  color: modernColors.primary,
                  position: 'relative',
                  display: 'inline-block',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    width: '40px',
                    height: '3px',
                    bgcolor: modernColors.primary,
                    bottom: -8,
                    left: 0
                  }
                }}
              >
                {"Sosyal Medya"}
              </Typography>
              
              <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
                {settings && settings.FacebookHandle && (
                  <IconButton
                    href={settings.FacebookHandle}
                    target="_blank"
                    aria-label="Facebook"
                    sx={{
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                      color: '#fff',
                      '&:hover': {
                        bgcolor: '#4267B2',
                        transform: 'translateY(-3px)'
                      },
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <FacebookIcon />
                  </IconButton>
                )}
                
                {settings && settings.TwitterHandle && (
                  <IconButton
                    href={settings.TwitterHandle}
                    target="_blank"
                    aria-label="Twitter"
                    sx={{
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                      color: '#fff',
                      '&:hover': {
                        bgcolor: '#1DA1F2',
                        transform: 'translateY(-3px)'
                      },
                      transition: 'all 0.3s ease'
                    }}
              >
                    <TwitterIcon />
                  </IconButton>
                )}
                
                {settings && settings.InstagramHandle && (
                  <IconButton
                    href={settings.InstagramHandle}
                    target="_blank"
                    aria-label="Instagram"
                    sx={{
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                      color: '#fff',
                      '&:hover': {
                        bgcolor: '#E1306C',
                        transform: 'translateY(-3px)'
                      },
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <InstagramIcon />
                  </IconButton>
                )}
              </Stack>
              
              <Box 
                sx={{ 
                  bgcolor: 'rgba(255, 255, 255, 0.05)', 
                  p: 2, 
                  borderRadius: '10px'
                }}
              >
                <Typography 
                  variant="body2" 
                  sx={{ 
                    fontFamily: FONT_FAMILY, 
                    color: 'rgba(255,255,255,0.7)',
                    mb: 1
                  }}
                >
                  {"Uygulamalarımızı İndirin"}
                </Typography>
                
                <Stack direction="row" spacing={2}>
                  {settings && settings.AppleStoreLink && (
                    <Button
                      variant="outlined"
                      sx={{
                        borderColor: 'rgba(255,255,255,0.2)',
                        color: '#fff',
                        '&:hover': {
                          borderColor: modernColors.primary,
                          bgcolor: 'rgba(255, 255, 255, 0.05)'
                        }
                      }}
                      size="small"
                    >
                      {"App Store"}
                    </Button>
                  )}
                  
                  {settings && settings.PlayStoreLink && (
                    <Button
                      variant="outlined"
                      sx={{
                        borderColor: 'rgba(255,255,255,0.2)',
                        color: '#fff',
                        '&:hover': {
                          borderColor: modernColors.primary,
                          bgcolor: 'rgba(255, 255, 255, 0.05)'
                        }
                      }}
                      size="small"
                    >
                      {"Play Store"}
                    </Button>
                  )}
                </Stack>
              </Box>
            </Grid>
          </Grid>
          
          <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)', mb: 2 }} />
          
          {/* Copyright */}
          <Box sx={{ textAlign: 'center' }}>
            <Typography 
              variant="body2" 
              sx={{ 
                fontFamily: FONT_FAMILY, 
                color: 'rgba(255,255,255,0.5)',
                fontSize: '0.75rem'
              }}
            >
              &copy; {1900 + new Date().getYear()} {" "}
          {settings && settings.CompanyWebsite ? (
              <a
                style={{
                    color: modernColors.primary,
                    textDecoration: 'none',
                    fontFamily: FONT_FAMILY
                }}
                href={settings.CompanyWebsite}
                target="_blank"
              >
                {settings.CompanyName}
              </a>
              ) : (
                t('company')
              )}
              {" - " + t('all_rights_reserved')}
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
}

HomeFooter.propTypes = {
  whiteFont: PropTypes.bool,
};
